export default __webpack_public_path__ + "static/media/ee.c05384da.svg";